import { call, select, takeEvery } from 'redux-saga/effects';

import { storage } from 'evee-ui-common/services';
import * as actionTypes from 'store/modules/app/actionTypes';
import { HEADER_NOTIFICATION_MODES } from 'store/modules/app/constants';
import { getHeaderNotificationMode } from 'store/modules/app/selectors';

function* onCloseHeaderNotification() {
  const mode = yield select(getHeaderNotificationMode);

  if (mode === HEADER_NOTIFICATION_MODES.session) {
    return;
  }

  yield call(storage.headerNotificationDismissed.save, 'true');
}

export default function* listenHeaderNotificationDismissed() {
  yield takeEvery(actionTypes.CLOSE_HEADER_NOTIFICATION, onCloseHeaderNotification);
}
